var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50033 0.583252H12.917C13.4695 0.583252 13.9994 0.802745 14.3901 1.19345C14.7808 1.58415 15.0003 2.11405 15.0003 2.66659C15.0003 3.21912 14.7808 3.74902 14.3901 4.13972C13.9994 4.53043 13.4695 4.74992 12.917 4.74992H2.50033C1.94779 4.74992 1.41789 4.53043 1.02719 4.13972C0.636486 3.74902 0.416992 3.21912 0.416992 2.66659C0.416992 2.11405 0.636486 1.58415 1.02719 1.19345C1.41789 0.802745 1.94779 0.583252 2.50033 0.583252ZM17.0837 17.2499H27.5003C28.0529 17.2499 28.5828 17.4694 28.9735 17.8601C29.3642 18.2508 29.5837 18.7807 29.5837 19.3333C29.5837 19.8858 29.3642 20.4157 28.9735 20.8064C28.5828 21.1971 28.0529 21.4166 27.5003 21.4166H17.0837C16.5311 21.4166 16.0012 21.1971 15.6105 20.8064C15.2198 20.4157 15.0003 19.8858 15.0003 19.3333C15.0003 18.7807 15.2198 18.2508 15.6105 17.8601C16.0012 17.4694 16.5311 17.2499 17.0837 17.2499Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5003 8.9165H2.50033C1.94779 8.9165 1.41789 9.136 1.02719 9.5267C0.636486 9.9174 0.416992 10.4473 0.416992 10.9998C0.416992 11.5524 0.636486 12.0823 1.02719 12.473C1.41789 12.8637 1.94779 13.0832 2.50033 13.0832H27.5003C28.0529 13.0832 28.5828 12.8637 28.9735 12.473C29.3642 12.0823 29.5837 11.5524 29.5837 10.9998C29.5837 10.4473 29.3642 9.9174 28.9735 9.5267C28.5828 9.136 28.0529 8.9165 27.5003 8.9165Z",
    fill: "#FE7F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.1a4d60ea1f85bad664a3d2605d96b0f4.svg";
export { ForwardRef as ReactComponent };